import React from 'react'
import {Link} from "react-router-dom";
import Logo from "../assets/images/logo@2x.png";
import Footer from "./Footer/Footer";

export default function SectionAside({title}) {
    return (
        <div className="section__aside">
            <div className="section__inner">
                <div className="section__inner-content">
                    <Link to="/" className="logo">
                        <img src={Logo} alt="" width="200" height="20"/>
                    </Link>

                    <div className="section__head">
                        <h1 className="section__title">{title ?? "Where exceptional talent meets extraordinary opportunity"}</h1>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    )
}